// Google Analytics Service ( GA4 )

const VAT_MAP = {
  'SE': 0.25,
  'NO': 0.25,
  'DK': 0.25,
  'DE': 0.19,
  'NL': 0.21,
  "AT": 0.20,
  "CH": 0.077,
  "GB": 0.20,
  "US": 0.06,
  "CA": 0.05,
  "AU": 0.10,
  "NZ": 0.15,
  "ZA": 0.15,
  "IN": 0.18,
  "PL": 0.23,
  "RO": 0.19,
  "BG": 0.20,
  "CZ": 0.21,
  "EE": 0.20,
  "FI": 0.24,
  "GR": 0.24,
  "HR": 0.25,
  "HU": 0.27,
  "IE": 0.23,
  "IT": 0.22,
  "LT": 0.21,
  "LU": 0.17,
  "LV": 0.21,
  "MT": 0.18,
  "PT": 0.23,
  "RO": 0.19,
  "SK": 0.20,
  "SI": 0.22,
  "ES": 0.21,
}

const GA = {

  onProductView: (item, list, position) => {
    if (typeof window !== undefined) {
      window.dataLayer.push({ ecommerce: null });
      // window.dataLayer.push({
      //   event: 'view_item',
      //   ecommerce: {
      //     currencyCode: item.price ? item.price.slice(-3) : 'SEK',
      //     impressions: [{
      //       name: item.name,
      //       id: item.sku,
      //       list: list,
      //       position: position,
      //       price: item.priceAsNumber,
      //       brand: item.brandName ? item.brandName : 'Flowlife',
      //       category: item.categoryName ? item.categoryName[0] : ''
      //     }]
      //   }
      // })
      // window.dataLayer.push({
      //   event: 'view_item',
      //   value: item.priceAsNumber,
      //   currency: item.price ? item.price.slice(-3) : 'SEK',
      //   items: [{
      //     item_name: item.name,
      //     item_id: item.sku,
      //     price: item.priceAsNumber,
      //     item_brand: item.brandName ? item.brandName : 'Flowlife',
      //     item_category: item.categoryName ? item.categoryName[0] : ''
      //   }]
      // });
    }
    // console.log('Impression: ', {
    //   event: 'view_item',
    //   ecommerce: {
    //     currencyCode: item.price ? item.price.slice(-3): 'SEK',
    //     impressions: [{
    //       name: item.name,
    //       id: item.sku,
    //       list: list,
    //       position: position,
    //       price: item.priceAsNumber,
    //       brand: item.brandName ? item.brandName : 'Flowlife',
    //       category: item.categoryName ? item.categoryName[0] : ''
    //     }]
    //   }
    // });
  },

  //Detail view
  onDetailView: (item, country) => {
    const tax = VAT_MAP[country.toUpperCase()] || 0.25;
    if (typeof window !== undefined) {
      window.dataLayer.push({ ecommerce: null });
      // window.dataLayer.push({
      //   event: 'detailView',
      //   ecommerce: {
      //     detail: {
      //       actionField: {
      //         list: list
      //       },
      //       products: [{
      //         name: item.name,
      //         id: item.sku,
      //         brand: item.brandName ? item.brandName : 'Flowlife',
      //         category: item.categoryName ? item.categoryName[0] : ''
      //       }]
      //     }
      //   }
      // })
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          value: Number(Number(item.priceAsNumber / (1 + tax)).toFixed(2)),
          currency: item.price ? item.price.slice(-3) : 'SEK',
          items: [{
            item_name: item.name,
            item_id: item.sku,
            discount: item.priceBeforeDiscountAsNumber ? Number(Number((item.priceBeforeDiscountAsNumber - item.priceAsNumber) / (1 + tax)).toFixed(2)) : 0,
            price: Number(Number(item.priceAsNumber / (1 + tax)).toFixed(2)),
            item_brand: item.brandName ? item.brandName : 'Flowlife',
            item_category: item.collectionName ? item.collectionName : ''
          }]
        }
      });
    }
    // console.log('Detail View: ', {
    //   event: 'detailView',
    //   ecommerce: {
    //     detail: {
    //       actionField: {
    //         list: list
    //       },
    //       products: [{
    //         name: item.name,
    //         id: item.sku,
    //         brand: item.brandName ? item.brandName : 'Flowlife',
    //         category: item.categoryName ? item.categoryName[0] : ''
    //       }]
    //     }
    //   }
    // });
  },

  // When item link is clicked
  onProductClick: (item, list, pos) => {
    if (typeof window !== undefined) {
      window.dataLayer.push({ ecommerce: null });
      // window.dataLayer.push({
      //   event: 'productClick',
      //   ecommerce: {
      //     click: {
      //       actionField: { list: list },
      //       products: [{
      //         name: item.title ? item.title : item.name,
      //         id: item.sku ? item.sku : item.centraProduct,
      //         //price: item.priceAsNumber ? item.priceAsNumber : '',
      //         //quantity: qty ? qty : 1,
      //         position: pos,
      //         brand: item.brandName ? item.brandName : 'Flowlife',
      //         category: item.categoryName ? item.categoryName[0] : ''
      //       }]
      //     }
      //   }
      // })
    }
    // console.log('Impression click: ', {
    //     event: 'productClick',
    //     ecommerce: {
    //       click: {
    //         actionField: {list: list},
    //         products: [{
    //           name: item.title ? item.title : item.name,
    //           id: item.sku ? item.sku : item.centraProduct,
    //           //price: item.priceAsNumber ? item.priceAsNumber : '',
    //           //quantity: qty ? qty : 1,
    //           position: pos,
    //           brand: item.brandName ? item.brandName : 'Flowlife',
    //           category: item.categoryName ? item.categoryName[0] : ''
    //         }]
    //       }
    //     }
    //   });
  },

  // When item added into cart
  addToCart: (item, list) => {
    if (typeof window !== undefined) {
      window.dataLayer.push({ ecommerce: null });
      // window.dataLayer.push({
      //   event: 'add_to_cart',
      //   ecommerce: {
      //     currencyCode: item.price.slice(-3),
      //     add: {
      //       actionField: {
      //         list: list
      //       },
      //       products: [{
      //         name: item.name,
      //         id: item.sku ? item.sku : item.centraProduct,
      //         price: item.priceAsNumber ? item.priceAsNumber : 0,
      //         quantity: 1,
      //         brand: item.brandName ? item.brandName : 'Flowlife',
      //         category: item.categoryName ? item.categoryName[0] : ''
      //       }]
      //     }
      //   }
      // })

      const tax = item.taxPercent || 0.25;
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          value: Number(Number(item.priceAsNumber / (1 + tax)).toFixed(2)),
          currency: item.price ? item.price.slice(-3) : 'SEK',
          items: [{
            item_name: item.name,
            item_id: item.sku,
            price: Number(Number(item.priceAsNumber / (1 + tax)).toFixed(2)),
            discount: item.priceBeforeDiscountAsNumber ? Number(Number((item.priceBeforeDiscountAsNumber - item.priceAsNumber) / (1 + tax)).toFixed(2)) : 0,
            item_brand: item.brandName ? item.brandName : 'Flowlife',
            quantity: 1,
            item_category: item.collectionName ? item.collectionName : '',
            item_list_name: list,
            item_list_id: list
          }]
        }
      });
    }
    // console.log('Pushed item: ', {
    //   event: 'addToCart',
    //   ecommerce: {
    //     currencyCode: item.price.slice(-3),
    //     add: {
    //       actionField: {
    //         list: list
    //       },
    //       products: [{
    //         name: item.name,
    //         id: item.sku ? item.sku : item.centraProduct,
    //         price: item.priceAsNumber ? item.priceAsNumber : 0,
    //         quantity: 1,
    //         brand: item.brandName ? item.brandName : 'Flowlife',
    //         category: item.categoryName ? item.categoryName[0] : ''
    //       }]
    //     }
    //   }
    // });
  },

  // When item removed from cart
  removeFromCart: (item, itemID, qty) => {
    if (typeof window !== undefined) {
      window.dataLayer.push({ ecommerce: null });
      // window.dataLayer.push({
      //   event: 'remove_from_cart',
      //   ecommerce: {
      //     //currencyCode: item.price.slice(-3),
      //     remove: {
      //       products: [{
      //         name: item.name ? item.name : '',
      //         id: item.sku ? item.sku : item.centraProduct,
      //         price: item.priceAsNumber ? item.priceAsNumber : '',
      //         quantity: qty ? qty : 1,
      //         brand: item.brandName ? item.brandName : 'Flowlife',
      //         category: item.categoryName ? item.categoryName[0] : ''
      //       }]
      //     }
      //   }
      // });
      const tax = item.taxPercent || 0.25;
      window.dataLayer.push({
        event: 'remove_from_cart',
        ecommerce: {
          value: Number(Number(item.priceAsNumber / (1 + tax)).toFixed(2)),
          currency: item.price ? item.price.slice(-3) : 'SEK',
          items: [{
            item_name: item.name,
            item_id: item.sku,
            price: Number(Number(item.priceAsNumber / (1 + tax)).toFixed(2)),
            discount: item.priceBeforeDiscountAsNumber ? Number(Number((item.priceBeforeDiscountAsNumber - item.priceAsNumber) / (1 + tax)).toFixed(2)) : 0,
            item_brand: item.brandName ? item.brandName : 'Flowlife',
            quantity: 1,
            item_category: item.collectionName ? item.collectionName : ''
          }]
        }
      });
    }
    // console.log('Removed item: ', {
    //   event: 'remove_from_cart',
    //   ecommerce: {
    //     items: [{
    //       item_name: item.title ? item.title : item.name,
    //       item_id: item.centraId ? item.centraId : item.centraProduct,
    //       price: item.priceAsNumber ? item.priceAsNumber : '',
    //       quantity: qty ? qty : 1,
    //       item_brand: item.brandName ? item.brandName : '',
    //       item_category: item.categoryName ? item.categoryName[0] : ''
    //     }]
    //   }
    // });
  },

  // When user enters checkout process
  onCheckout: (items, vouchers) => {
    if (typeof window !== undefined) {
      if (typeof window !== undefined && window.dataLayer) {
        window.dataLayer.push({ ecommerce: null });
        // window.dataLayer.push({
        //   event: 'begin_checkout',
        //   ecommerce: {
        //     checkout: {
        //       actionField: { step: 1, option: 'Init' },
        //       products: items.map(item => {
        //         return {
        //           name: item.product.name,
        //           id: item.product ? item.product.productSku : item.sku,
        //           price: item.totalPriceAsNumber,
        //           quantity: item.quantity,
        //           brand: item.product.brandName ? item.product.brandName : 'Flowlife',
        //           category: item.product.categoryName ? item.product.categoryName[0] : ''
        //         }
        //       })
        //     }
        //   }
        // });
        const tax = items.length > 0 ? Number(items[0].taxPercent / 100).toFixed(2) || 0.25 : 0.25;
        const coupons = vouchers && vouchers.length > 0 ? vouchers : [];
        const taxValue = 1 + Number(tax);
        window.dataLayer.push({
          event: 'begin_checkout',
          ecommerce: {
            value: Number(Number(items.reduce((acc, item) => acc + (item.totalPriceAfterDiscountAsNumber / taxValue), 0)).toFixed(2)),
            currency: items[0].price ? items[0].price.slice(-3) : 'SEK',
            coupon: coupons.length > 0 ? coupons[0].voucher : null,
            items: items.map(item => ({
              item_name: item.product.name,
              item_id: item.product ? item.product.productSku : item.sku,
              price: Number(Number(item.totalPriceAfterDiscountAsNumber / item.quantity / taxValue).toFixed(2)),
              discount: item.totalPriceAfterDiscountAsNumber ? Number(Number((item.totalPriceBeforeDiscountAsNumber - item.totalPriceAfterDiscountAsNumber) / item.quantity / taxValue).toFixed(2)) : 0,
              item_brand: item.brandName ? item.brandName : 'Flowlife',
              coupon: coupons.length > 0 ? coupons[0].voucher : null,
              quantity: item.quantity,
              item_category: item.product.collectionName ? item.product.collectionName : ''
            }))
          }
        });
        // console.log('Items in cart: ', {
        //   event: 'begin_checkout',
        //   ecommerce: {
        //     items: items.map( item => {
        //       return {
        //         item_name: item.product.name,
        //         item_id: item.item,
        //         price: item.totalPriceAsNumber,
        //         quantity: item.quantity,
        //         item_brand: item.product.brandName ? item.product.brandName : '',
        //         item_category: item.product.categoryName ? item.product.categoryName[0] : ''
        //       }
        //     })
        //   }
        // });
      }
    }
  },

  //
  onPurchase: (order) => {
    if (typeof window !== undefined) {
      window.dataLayer.push({ ecommerce: null });
      // window.dataLayer.push({
      //   event: 'purchase',
      //   ecommerce: {
      //     //currencyCode: order.totals.grandTotalPrice.slice(-3),
      //     purchase: {
      //       actionField: {
      //         id: order.order,
      //         affiliation: "Online Store",
      //         revenue: (order.totals.grandTotalPriceAsNumber - order.totals.grandTotalPriceTaxAsNumber),
      //         tax: order.totals.grandTotalPriceTaxAsNumber,
      //         shipping: order.totals.shippingPriceAsNumber,
      //         currency: order.currency,
      //         coupon: order.discounts.vouchers.length > 0 ? order.discounts.vouchers[0].voucher : '',
      //         email: order.address?.email ?? ''
      //       },
      //       products: order.items.map(item => {
      //         return {
      //           name: item.product.name,
      //           id: item.sku,
      //           price: item.product.priceAsNumber,
      //           quantity: item.quantity,
      //           brand: item.product.brandName,
      //           category: item.product.categoryName[0]
      //         }
      //       })
      //     }
      //   }
      // });

      const tax = order.items.length > 0 ? Number(order.items[0].taxPercent / 100).toFixed(2) || 0.25 : 0.25;
      const taxValue = 1 + Number(tax);

      window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
          value: Number(Number(order.items.reduce((acc, item) => acc + (item.totalPriceAfterDiscountAsNumber / taxValue), 0)).toFixed(2)),
          currency: order.currency,
          transaction_id: order.order,
          coupon: order.discounts.vouchers.length > 0 ? order.discounts.vouchers[0].voucher : null,
          shipping:Number(Number(order.totals.shippingPriceAsNumber / taxValue).toFixed(2)),
          tax: Number(order.totals.grandTotalPriceTaxAsNumber).toFixed(2),
          items: order.items.map(item => ({
            item_name: item.product.name,
            item_id: item.sku,
            coupon: order.discounts.vouchers.length > 0 ? order.discounts.vouchers[0].voucher : null,
            price: Number(Number(item.totalPriceAfterDiscountAsNumber / item.quantity / taxValue).toFixed(2)),
            discount: item.priceEachBeforeDiscountAsNumber ? Number(Number((item.totalPriceBeforeDiscountAsNumber - item.totalPriceAfterDiscountAsNumber) / item.quantity / taxValue).toFixed(2)) : 0,
            item_brand: item.brandName ? item.brandName : 'Flowlife',
            quantity: item.quantity,
            item_category: item.product.collectionName ? item.product.collectionName : ''
          }))
        }

      });
      let hrq = window.hrq || [];
      hrq.push([
        "trackConversion",
        {
          total: Number(order.totals.grandTotalPriceAsNumber).toFixed(2),
          orderNumber: order.order,
          email: order.address?.email ?? '',
          products: order.items.map(item => ({
            url: `https://www.flowlife.com/${item.product?.uri}/`,
            productNumber: item.sku,
            lineTotal: Number(item.totalPriceAsNumber).toFixed(2),
            quantity: item.quantity,
          }))
        },
        function () {
          console.log('HR Conversion');
        }
      ]);
    }
    // console.log('Purchase: ', {
    //   event: 'purchase',
    //   ecommerce: {
    //     transaction_id: order.order,
    //     affiliation: "Online Store",
    //     value: order.totals.grandTotalPriceAsNumber,
    //     tax: order.totals.grandTotalPriceTaxAsNumber,
    //     shipping: order.totals.shippingPriceAsNumber,
    //     currency: order.currency,
    //     coupon: order.discounts.vouchers[0].voucher,
    //     items: order.items.map( item => {
    //       return {
    //         item_name: item.product.name,
    //         price: item.product.priceAsNumber,
    //         quantity: item.quantity,
    //         item_brand: item.product.brandName,
    //         item_category: item.product.categoryName[0]
    //       }
    //     })
    //   }
    // });
  }
};

export default GA;